export default __webpack_public_path__ + "static/media/screen.15df9e7d.svg";